import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConversations } from '../../store/slices/messagesSlice';
import { fetchNotifications } from '../../store/slices/notificationsSlice';

import Navbar from './Navbar';
import Sidebar from './Sidebar';
import WalletBalance from '../features/wallet/WalletBalance';
import './Layout.css';


const Layout = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { conversations } = useSelector((state) => state.messages);
  const { notifications } = useSelector((state) => state.notifications);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    if (user && conversations.length === 0) {
      dispatch(fetchConversations());
    }
    if (user && notifications.length === 0) {
      dispatch(fetchNotifications());
    }
  }, [user, conversations.length, notifications.length, dispatch]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const handleHamburger = () => {
    if (window.innerWidth <= 992) {
      toggleSidebar();
    } else {
      toggleSidebarCollapse();
    }
  };

  return (
    <div className="lova-layout">
      <Navbar
        toggleSidebar={toggleSidebar}
        sidebarOpen={sidebarOpen}
        hamburgerToggle={handleHamburger}
      />
      <WalletBalance />

      <div className="lova-container">
        <Sidebar closeSidebar={closeSidebar} collapsed={sidebarCollapsed} sidebarOpen={sidebarOpen} />
        <main className={`lova-main-content ${sidebarCollapsed ? 'sidebar-collapsed' : 'sidebar-open'}`} onClick={closeSidebar}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
